import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ViewModuleOutlinedIcon from "@mui/icons-material/ViewModuleOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";

export const DashboardViewSettings = ({
  tab,
  panels,
  layoutState,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [panelsOpen, setPanelsOpen] = useState(false);

  const tabPanels = useMemo(
    () =>
      (tab?.items || [])
        .map((item) => panels?.[item.panel])
        .filter(Boolean),
    [panels, tab]
  );

  const hidden = useMemo(
    () => new Set(layoutState.hiddenPanels || []),
    [layoutState.hiddenPanels]
  );

  const closeMenu = () => setAnchorEl(null);

  const toggleEditing = () => {
    layoutState.setEditing((current) => !current);
    closeMenu();
  };

  const openPanels = () => {
    closeMenu();
    setPanelsOpen(true);
  };

  return (
    <>
      <Tooltip title="Configurar vista">
        <IconButton
          size="small"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <SettingsOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        <MenuItem onClick={toggleEditing}>
          <ListItemIcon>
            {layoutState.editing ? (
              <CheckOutlinedIcon fontSize="small" />
            ) : (
              <EditOutlinedIcon fontSize="small" />
            )}
          </ListItemIcon>
          <ListItemText>
            {layoutState.editing ? "Finalizar personalización" : "Personalizar vista"}
          </ListItemText>
        </MenuItem>

        <MenuItem onClick={openPanels}>
          <ListItemIcon>
            <ViewModuleOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Paneles</ListItemText>
        </MenuItem>

        {layoutState.hasOverrides && (
          <MenuItem
            onClick={() => {
              layoutState.resetCurrentBreakpoint();
              closeMenu();
            }}
          >
            <ListItemIcon>
              <RestartAltOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Restablecer vista</ListItemText>
          </MenuItem>
        )}
      </Menu>

      <Dialog
        open={panelsOpen}
        onClose={() => setPanelsOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Paneles de {tab?.titulo || "la pestaña"}
        </DialogTitle>
        <DialogContent dividers>
          {tabPanels.length ? (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {tabPanels.map((panel) => (
                <FormControlLabel
                  key={panel.key}
                  control={
                    <Switch
                      checked={!hidden.has(panel.key)}
                      onChange={() =>
                        layoutState.togglePanelVisibility(panel.key)
                      }
                    />
                  }
                  label={panel.titulo || panel.key}
                  sx={{ m: 0, py: 0.5 }}
                />
              ))}
            </Box>
          ) : (
            <Typography color="text.secondary">
              Esta pestaña no contiene paneles.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPanelsOpen(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
